const PREFIXO_NOME_ANEXO = /^ROV_(\d+)_/i;

function numeroIdentificador(valor) {
  if (valor == null || !/^\d+$/.test(String(valor).trim())) return null;
  const numero = Number(valor);
  return Number.isSafeInteger(numero) && numero >= 0 ? numero : null;
}

export function extrairSqUploadDoNome(nome) {
  const base = String(nome || "")
    .replace(/\\/g, "/")
    .split("/")
    .pop();
  const encontrado = base.match(PREFIXO_NOME_ANEXO);
  return encontrado ? numeroIdentificador(encontrado[1]) : null;
}

export function obterProximoSqUploadAnexo(anexos = [], alvo = null) {
  let maiorSqUpload = null;
  const visitados = new Set();
  const pendentes = [...(Array.isArray(anexos) ? anexos : []), alvo];

  while (pendentes.length) {
    const anexo = pendentes.pop();
    if (!anexo || typeof anexo !== "object" || visitados.has(anexo)) continue;
    visitados.add(anexo);

    const identificadores = [
      anexo.sqUpload,
      anexo.substituindoSqUpload,
      extrairSqUploadDoNome(anexo.nome)
    ];

    identificadores.forEach(valor => {
      const numero = numeroIdentificador(valor);
      if (numero != null && (maiorSqUpload == null || numero > maiorSqUpload)) {
        maiorSqUpload = numero;
      }
    });

    if (anexo.anexoAnterior) pendentes.push(anexo.anexoAnterior);
  }

  return maiorSqUpload == null ? null : maiorSqUpload + 1;
}

function formatarDataHora(dataHora) {
  if (!(dataHora instanceof Date) || Number.isNaN(dataHora.getTime())) {
    return null;
  }

  const pad = valor => String(valor).padStart(2, "0");
  return [
    dataHora.getFullYear(),
    pad(dataHora.getMonth() + 1),
    pad(dataHora.getDate()),
    pad(dataHora.getHours()),
    pad(dataHora.getMinutes()),
    pad(dataHora.getSeconds())
  ].join("");
}

export function montarNomeArquivoAnexo({
  sqUpload,
  sqOcorrencia,
  cdPessoaCooperado,
  sqTipoAnexo,
  nomeOriginal,
  dataHora = new Date()
} = {}) {
  const identificadores = [
    sqUpload,
    sqOcorrencia,
    cdPessoaCooperado,
    sqTipoAnexo
  ].map(numeroIdentificador);
  const extensao = String(nomeOriginal || "").match(/\.([a-z0-9]+)$/i);
  const dataHoraFormatada = formatarDataHora(dataHora);

  if (
    identificadores.some(valor => valor == null) ||
    !extensao ||
    !dataHoraFormatada
  ) {
    return null;
  }

  const [
    sqUploadNormalizado,
    sqOcorrenciaNormalizada,
    cooperadoNormalizado,
    tipoNormalizado
  ] = identificadores.map(valor => String(valor).padStart(8, "0"));

  return `ROV_${sqUploadNormalizado}_${sqOcorrenciaNormalizada}_${cooperadoNormalizado}_${tipoNormalizado}_${dataHoraFormatada}.${extensao[1].toLowerCase()}`;
}

export function montarNomeArquivoOpcional(nomeOriginal, id) {
  const nome = String(nomeOriginal || "imagem")
    .replace(/\\/g, "/")
    .split("/")
    .pop();
  const extensao = nome.match(/\.[a-z0-9]+$/i);
  const base = extensao ? nome.slice(0, -extensao[0].length) : nome;
  const identificador = String(id).replace(/[^a-z0-9-]/gi, "");
  return base + "_" + identificador + (extensao ? extensao[0] : "");
}
